'use client';

import Image from 'next/image';

export default function CareerEmpowermentSection() {
  return (
    <section className="w-full py-10 md:py-16 bg-white">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Heading Section */}
        <div className="mb-10">
          <p className="text-sm md:text-base text-[#002726] font-medium uppercase tracking-wide mb-2">
            FUELING YOUR AMBITION
          </p>
          <h2 className="text-2xl md:text-4xl font-medium text-[#002726]">
            Empowering Careers with Skills, Community, and Mentorship
          </h2>
        </div>
        
        {/* Cards Layout */}
        <div className="space-y-8">
          {/* First Card - Full width with side-by-side layout inside a single rounded card */}
          <div className="bg-[#FFFAF1] rounded-3xl overflow-hidden p-5 md:p-8 border border-[#97A7A666]/40">
            <div className="flex flex-col-reverse md:flex-row justify-between">
              {/* Text Content */}
              <div className="md:w-[55%] pr-4 md:mt-0 mt-4">
                <h3 className="text-xl font-semibold text-[#002726] mb-4">What Drives Us</h3>
                <p className="text-[#002726] text-sm md:text-base">
                  While college was an enjoyable experience for many, it didn't equip us 
                  with the necessary skills to thrive in today's online landscape. We aim to 
                  change that by collaborating with top industry leaders to create career-focused 
                  programs that can help you start a new career or enhance your existing skills.
                </p>
              </div>
              
              {/* Image - Properly right-aligned */}
              <div className="md:w-[40%] h-[240px] md:h-[288px] relative mt-4 md:mt-0 md:ml-auto">
                <Image
                  src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/abc1.png"
                  alt="GrowthSchool Office"
                  fill
                  className="object-cover rounded-xl"
                />
              </div>
            </div>
          </div>
          
          {/* Two Column Cards with 60%/40% split using flex */}
          <div className="flex flex-col md:flex-row gap-8">
            {/* Second Card - Community - 60% width */}
            <div className="bg-[#FFFAF1] rounded-3xl overflow-hidden md:w-[60%] p-5 md:p-8 border border-[#97A7A666]/40 flex flex-col">
              <div>
                <h3 className="text-xl font-semibold text-[#002726] mb-4">The Power of Community</h3>
                <p className="text-[#002726] text-sm md:text-base mb-6">
                  You learn more from your peers than your mentors or teachers in the 
                  real world. You can have better ideas & have better professional 
                  outcomes when like-minded people surround you. Our programs are 
                  focused on community learning & engagement.
                </p>
              </div>
              
              {/* Image - Inside the same rounded card */}
              <div className="h-[288px] md:h-[380px] relative mt-auto">
                <Image
                  src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/abc2.webp"
                  alt="Community Learning"
                  fill
                  className="object-cover rounded-2xl"
                />
              </div>
            </div>
            
            {/* Third Card - Mentors - 40% width */}
            <div className="bg-[#FFFAF1] rounded-3xl overflow-hidden md:w-[40%] p-5 md:p-8 border border-[#97A7A666]/40 flex flex-col">
              <div>
                <h3 className="text-xl font-semibold text-[#002726] mb-4">Support from Great Mentors</h3>
                <p className="text-[#002726] text-sm md:text-base mb-6">
                  Having a supportive and knowledgeable mentor can greatly enhance your 
                  career journey. They can help you avoid pitfalls and progress more 
                  smoothly. We| only collaborate with the best of the best - the top 1% of 
                  professionals in their field.
                </p>
              </div>
              
              {/* Image - Inside the same rounded card */}
              <div className="h-[288px] md:h-[380px] relative mt-auto">
                <Image
                  src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/abc3.png"
                  alt="GrowthSchool Mentors"
                  fill
                  className="object-cover rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}